import React from 'react';

import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onAddNewSong }) => {
  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-12 text-center">
      <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="Music" size={32} className="text-blue-100" />
      </div>
      
      <h3 className="text-xl font-heading font-semibold text-white mb-3">
        No Songs Yet
      </h3>
      
      <p className="text-blue-100 font-body mb-8 max-w-md mx-auto leading-relaxed">
        Start building your song database by adding your first comprehensive song analysis.
      </p>
      
      <Button
        onClick={onAddNewSong}
        iconName="Plus"
        iconPosition="left"
        className="bg-white text-indigo-900 hover:bg-gray-100 rounded-lg"
      >
        Add First Song
      </Button>
    </div>
  );
};

export default EmptyState;